import styled from 'styled-components';

const Box = styled.div`
img {
    filter: inherit !important;
    margin-right: 10px;
    width: 5%;
  }
  p.strong {
    font-weight: bold !important;
    font-size: 11px !important;
}
strong {
  font-size: 10px !important;
}
.error-controlado hr{
    margin-top: 0;
      margin-bottom: 1rem;
  }
  .contenedor-mensaje-error {
    background-color: #F9D4D5;
    padding: 9px;
    display: flex;
    align-items: flex-start;
  }
  .contenedor-mensaje-error p {
    color: #BF0238;
    font-size: 10px;
    font-weight: 400;
    line-height: 18px;
  }

  @media (max-width: 376px){
    .contenedor-mensaje-error p {
      font-size: 9px !important;
    }
    .contenedor-mensaje-error p.strong {
      font-size: 10px !important;
    }
    .contenedor-mensaje-error img {
      width: 12px !important;
    }
  }

  @media (max-width: 321px){
    .contenedor-mensaje-error p {
      font-size: 9px !important;
    }
    .contenedor-mensaje-error p.strong {
      font-size: 10px !important;
    }
    .contenedor-mensaje-error img {
      width: 12px !important;
    }
  }
`;

export default Box;